import { render, staticRenderFns } from "./EntityDetailModal.vue?vue&type=template&id=603ba56b&scoped=true&"
import script from "./EntityDetailModal.vue?vue&type=script&lang=js&"
export * from "./EntityDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./EntityDetailModal.vue?vue&type=style&index=0&id=603ba56b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ba56b",
  null
  
)

export default component.exports